export type DatepickerDay = {
  class: string;
  date: Date;
};

export enum PopupPosition {
  auto = "auto",
  top = "top",
  bottom = "bottom",
}

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd";
